import { graphql } from 'gatsby';
import * as React from 'react';
import { DateUtils } from 'react-day-picker';
import { useMonthRange } from '../hooks/use-month-range';
import { ServiceSchedule } from '../shared-types';
import { Calendar } from './calendar';
import styles from './schedule-calendar.module.scss';

type ScheduleCalendarProps = {
  schedules: ServiceSchedule[];
};

export const ScheduleCalendar = (props: ScheduleCalendarProps) => {
  const schedules = React.useMemo(
    () =>
      props.schedules.map(node => ({
        date: new Date(node.date),
        time: node.time,
      })),
    [props.schedules]
  );
  const { lastMonthDate, currentDateRef, currentMonthStartRef } = useMonthRange(
    props.schedules
  );

  return (
    <Calendar
      fromMonth={currentMonthStartRef.current}
      toMonth={lastMonthDate}
      disabledDays={[
        {
          before: currentDateRef.current,
        },
      ]}
      renderDay={(date, { disabled }) => {
        if (disabled) {
          return (
            <span className={`${styles.day} ${styles.disabled}`}>
              {date.getDate()}
            </span>
          );
        }

        const matchedSchedule = schedules.find(sch =>
          DateUtils.isSameDay(sch.date, date)
        );
        if (matchedSchedule) {
          return (
            <>
              <span className={styles.day}>{date.getDate()}</span>
              {matchedSchedule.time.map((time, i) => (
                <div key={i}>
                  <span className={styles.time}>{time}</span>
                </div>
              ))}
            </>
          );
        } else {
          return (
            <span className={`${styles.day} ${styles.disabled}`}>
              {date.getDate()}
            </span>
          );
        }
      }}
    />
  );
};

export const query = graphql`
  fragment ScheduleCalendar on ScheduleYaml {
    date
    time
  }
`;
